module.exports = __webpack_public_path__ + "87de4afce1297f3679c79d9db5579489.svg";